export default __webpack_public_path__ + "static/scruggs-bf7e579e1addb745094b2c950b707136.jpg";